<script>
export default {
	props: {
		informationtext: {
			type: String,
			default: "Tem certeza que deseja efetuar essa ação?",
		},
		showDialog: {
			type: Boolean,
			default: false,
		}
	},
    methods: {
		ok() {
			this.$emit('ok');
		},
	}
}
</script>
<template>
	<div>
		<b-modal v-model="showDialog" ref="information-modal" centered title="Informação" title-class="font-18">
			<h5>{{informationtext}}</h5>
			<template v-slot:modal-footer class="mt-0">
				<b-button variant="primary" @click="ok()">Ok</b-button>
			</template>			
		</b-modal>
	</div>
</template>